/**
 * Homepage component with navigation to Sign In and Sign Up pages.
 * Displays welcome message and action buttons for authentication.
 */

/// <reference types="../types/css-modules" />
import { useNavigate } from 'react-router-dom';
import styles from '../styles/Landing.module.css';

/**
 * Homepage component.
 * @returns JSX.Element representing the landing page with navigation buttons.
 */
function Landing() {
  const navigate = useNavigate();

  const handleSignIn = () => navigate('/sign-in');
  const handleSignUp = () => navigate('/sign-up');

  return (
    <div className={styles.container}>
      {/* Decorative rings */}
      <div className={`${styles.ring} ${styles.ring1}`} />
      <div className={`${styles.ring} ${styles.ring2}`} />

      {/* Floating orbs */}
      <div className={`${styles.orb} ${styles.orbGold}`} />
      <div className={`${styles.orb} ${styles.orbGreen}`} />
      <div className={`${styles.orb} ${styles.orbMid}`} />

      {/* Main content */}
      <div className={styles.inner}>
        {/* Logo */}
        <img
          onLoad={(e) => e.currentTarget.classList.add('loaded')}
          src="/GroupSoup.png"
          alt="GroupSoup"
          className={styles.logoImg}
        />

        {/* Title */}
        <h1 className={styles.title}>
          Welcome to <span className={styles.titleAccent}>GroupSoup</span>!
        </h1>

        {/* Tagline */}
        <p className={styles.tagline}>
          Find your people. Discover local events. Plan together.
        </p>

        {/* CTA Buttons */}
        <div className={styles.buttonContainer}>
          <button
            className={`${styles.button} ${styles.signInButton}`}
            onClick={handleSignIn}
          >
            Sign In
          </button>
          <button
            className={`${styles.button} ${styles.signUpButton}`}
            onClick={handleSignUp}
          >
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
}

export default Landing;
